<template>
  <div class="fee-remind-wrap" v-if="showBanner">
    <div class="fee-remind-card fee-remind-card--pending" v-if="!user.isCheckMemFee && !user.isMemValid">
      <div class="fee-remind-card__main">
        <div class="fee-remind-card__icon">
          <i></i>
        </div>
        <div class="fee-remind-card__content">
          <div class="fee-remind-card__title">您的会员年费尚未缴纳</div>
          <div class="fee-remind-card__desc">
            完成年费缴纳并上传打款凭证后，即可享受学会提供的全部会员服务。
            <span class="fee-remind-card__amount" v-if="feeAmount !== '-'">应缴 <em>{{ feeAmount }}</em> 元</span>
          </div>
        </div>
        <button class="fee-remind-card__btn" type="button" @click="showPayModal">
          立即缴纳会费
          <i class="fee-remind-card__btn-arrow"></i>
        </button>
      </div>
    </div>

    <div class="fee-remind-card fee-remind-card--review" v-if="user.isCheckMemFee">
      <div class="fee-remind-card__main">
        <div class="fee-remind-card__icon fee-remind-card__icon--review">
          <i></i>
        </div>
        <div class="fee-remind-card__content">
          <div class="fee-remind-card__title">会费缴纳凭证审核中</div>
          <div class="fee-remind-card__desc">我们已收到您提交的打款凭证，正在核实中，请耐心等待。审核通过后将自动更新您的会员状态，并可下载会员证书。</div>
        </div>
      </div>
    </div>

    <Modal :visible="payVisible">
      <PayModal
        v-if="payVisible"
        @cancel="closeModal"
        @confirm="confirmPay"
      ></PayModal>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal';
import PayModal from './PayModal';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'FeeRemindBanner',
  components: {
    Modal,
    PayModal,
  },
  data() {
    return {
      payVisible: false,
    };
  },
  computed: {
    ...mapState(['user']),
    showBanner() {
      return this.user
        && (this.user.memType === 'personal' || this.user.memType === 'org');
    },
    feeAmount() {
      if (!this.user) {
        return '-';
      }
      if (this.user.memType === 'personal') {
        return 250;
      }
      const key = this.user.memOrgVo && this.user.memOrgVo.orgTypeDicKey;
      if (key === '1503') return 3000;
      if (key === '1502') return 6000;
      if (key === '1501') return 9000;
      return '-';
    },
  },
  methods: {
    ...mapActions(['getUserInfo']),
    showPayModal() {
      this.payVisible = true;
    },
    closeModal() {
      this.payVisible = false;
    },
    confirmPay() {
      this.getUserInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.fee-remind-wrap {
  width: 100%;
}

.fee-remind-card {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;

  &--pending {
    background: #fff8f0;
    border: 1px solid #ffbb96;
    box-shadow: 0 6px 20px rgba(250, 84, 28, 0.16);
  }

  &--review {
    background: #fffbe6;
    border: 1px solid #ffe58f;
    box-shadow: 0 6px 20px rgba(250, 173, 20, 0.14);
  }

  &__main {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    padding: 22px 28px;
    gap: 20px;
  }

  &__icon {
    flex-shrink: 0;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #fff2e8;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #ffbb96;

    > i {
      display: block;
      width: 26px;
      height: 26px;
      background: url(../../../assets/images/icon-notice.svg) no-repeat center center;
      background-size: contain;
      filter: invert(45%) sepia(86%) saturate(1200%) hue-rotate(346deg) brightness(101%) contrast(101%);
    }

    &--review {
      background: #fffbe6;
      border-color: #ffe58f;

      > i {
        width: 24px;
        height: 24px;
        background: none;
        border: 3px solid #faad14;
        border-top-color: transparent;
        border-radius: 50%;
        filter: none;
        animation: fee-spin 1.2s linear infinite;
      }
    }
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #d4380d;
    line-height: 1.3;
    margin-bottom: 8px;
  }

  &--review &__title {
    color: #d48806;
  }

  &__desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #873800;
    line-height: 1.6;
  }

  &--review &__desc {
    color: #874d00;
  }

  &__amount {
    display: inline-block;
    margin-left: 4px;
    padding: 2px 10px;
    border-radius: 12px;
    background: #fff2e8;
    border: 1px solid #ffbb96;
    font-size: 13px;
    color: #d4380d;

    em {
      font-style: normal;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      margin: 0 2px;
      color: #fa541c;
    }
  }

  &__btn {
    flex-shrink: 0;
    height: 44px;
    padding: 0 28px;
    border: none;
    border-radius: 22px;
    background: linear-gradient(135deg, #ff9c6e 0%, #ff6b35 100%);
    color: #ffffff;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 4px 14px rgba(255, 107, 53, 0.35);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 18px rgba(255, 107, 53, 0.42);
    }

    &:active {
      transform: translateY(0);
    }
  }

  &__btn-arrow {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-top: 2px solid #ffffff;
    border-right: 2px solid #ffffff;
    transform: rotate(45deg);
    margin-left: 2px;
  }
}

@keyframes fee-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
